// import React, { useState, useContext, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   CssBaseline,
//   TextField,
//   FormControlLabel,
//   Checkbox,
//   CircularProgress,
//   Typography,
//   InputAdornment,
//   IconButton,
//   Link as MUILink,
//   Paper,
//   Fade,
// } from "@mui/material";
// import { AuthContext } from "./../AuthContext/AuthContext";
// import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";
// import { useNavigate, Link } from "react-router-dom";
// import { BASE_URL, Notification_Url } from "./../Api/ApiUrls";


// import Property_pincoder from "./../../../src/Images/property_pincode_new.png";
// const Login = () => {
//   const [identifier, setIdentifier] = useState("");
//   const [loading, setLoading] = useState(false);

//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const { login, guestLogin, userId, sessionId } = useContext(AuthContext);


// useEffect(() => {
//   if (userId && sessionId) {
//     navigate("/dashboard");
//   }
// }, [userId, sessionId, navigate]);


//   const handleGuestLogin = () => {
//     guestLogin();
//     navigate("/dashboard", {
//       state: { isGuest: true },
//     });
//   };

//   useEffect(() => {
//     console.log("Initial fcmToken from window:", window.fcmToken);
//   }, []);

//   const checkHasActiveFreePlan = async (userId) => {
//     try {
//       const res = await fetch(`${BASE_URL}/Get-all-plan/${userId}/`);
//       const plans = await res.json();

//       if (!Array.isArray(plans)) return false;

//       return plans.some(
//         (plan) =>
//           plan.plan_name === "Free" &&
//           plan.status === true &&
//           new Date(plan.expired_date) > new Date(),
//       );
//     } catch (err) {
//       console.error("Check plan failed", err);
//       return false;
//     }
//   };

//   const autoSubscribeFreePlan = async (userId) => {
//     try {
//       await fetch(`${BASE_URL}/subscribe/free/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           user_id: userId,
//           plan_name: "Free",
//           // trial_days: 365,
//         }),
//       });
//       return true;
//     } catch (err) {
//       console.error("Auto subscribe failed", err);
//       return false;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     const cleanIdentifier = identifier.trim();
//     const cleanPassword = password.trim();

//     if (!cleanIdentifier || !cleanPassword) {
//       setError("Mobile number / Email and password are required");
//       return;
//     }
//   setLoading(true); 
//     try {
//       const response = await fetch(`${BASE_URL}/login/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           identifier: cleanIdentifier,
//           password: cleanPassword,
//         }),
//       });

//       const data = await response.json();

//       console.log("Login Data=", data);

//       if (!response.ok) {
//   if (data.error === "Invalid Identifier.") {
//     setError("Invalid Email/Mobile number.");
//   } else {
//     setError(data.error || "Invalid credentials");
//   }
//   return;
// }

//       // ✅ SAVE LOGIN
//       login(data.user_id, data.session_token);

//         localStorage.setItem("isAuthenticated", "true");
//         localStorage.setItem("user_id", data.user_id);
//         localStorage.setItem("session_token", data.session_token);

//       // ✅ 🔥 ADD THIS BLOCK
//       if (window.ReactNativeWebView) {
//         window.ReactNativeWebView.postMessage(
//           JSON.stringify({
//             user_id: data.user_id,
//             session_token: data.session_token,
//             username: data.username,
//           }),
//         );
//       }

//        // 🔥 CHECK TERMS AFTER LOGIN (SECURE WAY)
//     const userRes = await fetch(
//       `${BASE_URL}/users/${data.user_id}/`,
//       {
//         headers: {
//           "Authorization": `Bearer ${data.session_token}`,
//         },
//       }
//     );

//     const userData = await userRes.json();

//     if (!userData.tersm_and_condition) {
//       // 🚀 Redirect to Terms page
//       navigate("/termsandconditions", {
//         state: { fromLogin: true },
//       });
//       return;
//     }

//       const userId = data.user_id;

//       // ✅ CHECK IF FREE PLAN EXISTS
//       const hasFreePlan = await checkHasActiveFreePlan(userId);

//       let showPopup = false;

//       // ✅ APPLY FREE PLAN ONLY IF NOT EXISTS
//       if (!hasFreePlan) {
//         const subscribed = await autoSubscribeFreePlan(userId);
//         if (subscribed) {
//           showPopup = true;
//           localStorage.setItem(`free_plan_popup_shown_${userId}`, "true");
//         }
//       }

//       navigate("/dashboard", {
//         state: {
//           showFreePlanPopup: showPopup,
//         },
//       });
//       // navigate("/dashboard");
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong. Please try again later.");
//      } finally {
//     setLoading(false); // ✅ ALWAYS STOP LOADING
//   } };

//   return (
//     <Fade in timeout={700}>
//       <Box
//         sx={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #0d0d25, #000)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           py: 6,
//         }}
//       >
//         <Container maxWidth="xs">
//           <CssBaseline />
//           <Paper
//             elevation={10}
//             sx={{
//               p: 4,
//               borderRadius: 4,
//               background: "rgba(255, 255, 255, 0.02)",
//               border: "1px solid rgba(255, 215, 0, 0.3)",
//               backdropFilter: "blur(10px)",
//               textAlign: "center",
//               color: "#fff",
//             }}
//           >
//             <Box
//               component="img"
//               src={Property_pincoder} // Make sure this variable is properly imported
//               alt="Land Nest Logo"
//               sx={{
//                 width: 180,
//                 height: 130,
//                 mb: 2,
//                 mx: "auto",
//                 borderRadius: 2,
//                 boxShadow: "0 0 20px #ffd700",
//                 display: "block",
//               }}
//             />
//             <Typography
//               variant="h5"
//               sx={{ color: "#f7e896", fontWeight: 600, mb: 2 }}
//             >
//               Welcome Back
//             </Typography>

//             {error && (
//               <Typography color="error" sx={{ fontSize: 14, mb: 2 }}>
//                 {error}
//               </Typography>
//             )}

//             <Box component="form" onSubmit={handleSubmit}>
//               {/* ✅ EMAIL OR MOBILE (SPACES ALLOWED) */}
//               <TextField
//                 margin="normal"
//                 required
//                 fullWidth
//                 label="Mobile Number or Email"
//                 type="text"
//                 value={identifier}
//                 onChange={(e) => setIdentifier(e.target.value.toLowerCase())}
//                 InputProps={{
//                   sx: {
//                     backgroundColor: "rgba(255,255,255,0.05)",
//                     borderRadius: 2,
//                     color: "white",
//                   },
//                 }}
//                 InputLabelProps={{ style: { color: "#ccc" } }}
//               />

//               {/* ✅ PASSWORD */}
//               <TextField
//                 margin="normal"
//                 required
//                 fullWidth
//                 label="Password"
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 InputProps={{
//                   sx: {
//                     backgroundColor: "rgba(255,255,255,0.05)",
//                     borderRadius: 2,
//                     color: "white",
//                   },
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setShowPassword(!showPassword)}
//                         edge="end"
//                         sx={{ color: "rgb(248, 227, 111)" }}
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 InputLabelProps={{ style: { color: "#ccc" } }}
//               />

//               {/* <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={rememberMe}
//                     onChange={() => setRememberMe(!rememberMe)}
//                     sx={{ color: '#f7e896' }}
//                   />
//                 }
//                 label={<Typography variant="body2" sx={{ color: '#ccc' }}>Remember me</Typography>}
//               /> */}

//        <Button
//   type="submit"
//   fullWidth
//   variant="contained"
//   disabled={loading}
//   startIcon={!loading && <Lock />}
//   sx={{
//     mt: 2,
//     mb: 2,
//      background: "linear-gradient(135deg, #f1e57c, #e6ce45)",
//     color: "#000",
//     fontWeight: "bold",
//   }}
// >
//   {loading ? (
//     <CircularProgress size={24} sx={{ color: "#000" }} />
//   ) : (
//     "Sign In"
//   )}
// </Button>


//               <Button
//   variant="contained"
//   onClick={handleGuestLogin}
//   sx={{
//     mt: 3,
//     mb: 2,
//     px: 2, // horizontal padding
//     background: "linear-gradient(135deg, #888, #aaa)",
//     color: "#000",
//     fontWeight: "bold",
//     alignSelf: "center", // center inside flex column
//     width: "auto", // size based on content
//     "&:hover": {
//       background: "linear-gradient(135deg, #ffe85c, #f0d53e)",
//     },
//   }}
// >
//   Continue as Guest
// </Button>
//               <Box display="flex" justifyContent="space-between">
//                 <MUILink
//                   component={Link}
//                   to="/register"
//                   variant="body2"
//                   sx={{ color: "rgb(250, 225, 85)" }}
//                 >
//                   Create account
//                 </MUILink>
//                 <MUILink
//                   component={Link}
//                   to="/forgot"
//                   variant="body2"
//                   sx={{ color: "rgb(250, 228, 101)" }}
//                 >
//                   Forgot password?
//                 </MUILink>
//               </Box>

//               <Box
//                 display="flex"
//                 justifyContent="center"
//                 flexWrap="wrap"
//                 gap={2}
//                 sx={{ mt: 3 }}
//               >
//                 <MUILink
//                   component={Link}
//                   to="/termsandconditions"
//                   variant="caption"
//                   sx={{ color: "#ccc", textDecoration: "underline" }}
//                 >
//                   Terms & Conditions
//                 </MUILink>
//                 <MUILink
//                   component={Link}
//                   to="/privacypolicy"
//                   variant="caption"
//                   sx={{ color: "#ccc", textDecoration: "underline" }}
//                 >
//                   Privacy Policy
//                 </MUILink>
//                 <MUILink
//                   component={Link}
//                   to="/refundpolicy"
//                   variant="caption"
//                   sx={{ color: "#ccc", textDecoration: "underline" }}
//                 >
//                   Refund Policy
//                 </MUILink>
//               </Box>
//             </Box>
//           </Paper>
//         </Container>
//       </Box>
//     </Fade>
//   );
// };

// export default Login;
// import React, { useState, useContext, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   CssBaseline,
//   TextField,
//   CircularProgress,
//   Typography,
//   InputAdornment,
//   IconButton,
//   Link as MUILink,
//   Paper,
//   Fade,
// } from "@mui/material";
// import { AuthContext } from "./../AuthContext/AuthContext";
// import {
//   Visibility,
//   VisibilityOff,
//   Lock,
//   Phone as PhoneIcon,
//   Person as PersonIcon,
// } from "@mui/icons-material";
// import { useNavigate, Link } from "react-router-dom";
// import { BASE_URL } from "./../Api/ApiUrls";

// import Property_pincoder from "./../../../src/Images/logo-main-removebg-preview.png";
// import LoginBg from "./../../../src/Images/bg-logo-pp2.jpeg";

// // ── Palette ──
// const GOLD = "#C9A24B";
// const GOLD_LIGHT = "#F1E57C";
// const GOLD_DARK = "#8C6B23";
// const INPUT_BG = "#1C1C1C";
// const INPUT_BORDER = "rgba(201,162,75,0.75)";

// /* ============================================================
//    Gold city skyline (line art) — bottom-right decoration
//    ============================================================ */
// const SkylineArt = ({ width = 150, height = 90 }) => (
//   <Box
//     component="svg"
//     viewBox="0 0 300 180"
//     xmlns="http://www.w3.org/2000/svg"
//     sx={{
//       width,
//       height,
//       display: "block",
//       opacity: 0.95,
//       pointerEvents: "none",
//     }}
//   >
//     <defs>
//       <linearGradient id="goldLine" x1="0" y1="0" x2="0" y2="1">
//         <stop offset="0%" stopColor="#F1E57C" />
//         <stop offset="55%" stopColor="#C9A24B" />
//         <stop offset="100%" stopColor="#8C6B23" />
//       </linearGradient>
//     </defs>

//     <g fill="none" stroke="url(#goldLine)" strokeWidth="2.4" strokeLinejoin="round">
//       <path d="M40 160 L40 70 L60 55 L80 70 L80 160" />
//       <path d="M40 90 L80 90" />
//       <path d="M40 110 L80 110" />
//       <path d="M50 70 L50 160" />
//       <path d="M70 70 L70 160" />
//       <path d="M120 160 L120 100 Q150 60 180 100 L180 160" />
//       <path d="M120 120 L180 120" />
//       <path d="M150 78 L150 100" />
//       <path d="M200 160 L200 60 L220 45 L240 60 L240 160" />
//       <path d="M200 80 L240 80" />
//       <path d="M200 100 L240 100" />
//       <path d="M210 60 L210 160" />
//       <path d="M230 60 L230 160" />
//       <path d="M10 162 L290 162" strokeWidth="2.8" />
//     </g>
//   </Box>
// );

// const Login = () => {
//   const [identifier, setIdentifier] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const { login, guestLogin, userId, sessionId } = useContext(AuthContext);

//   useEffect(() => {
//     if (userId && sessionId) navigate("/dashboard");
//   }, [userId, sessionId, navigate]);

//   const handleGuestLogin = () => {
//     guestLogin();
//     navigate("/dashboard", { state: { isGuest: true } });
//   };

//   const checkHasActiveFreePlan = async (uid) => {
//     try {
//       const res = await fetch(`${BASE_URL}/Get-all-plan/${uid}/`);
//       const plans = await res.json();
//       if (!Array.isArray(plans)) return false;
//       return plans.some(
//         (plan) =>
//           plan.plan_name === "Free" &&
//           plan.status === true &&
//           new Date(plan.expired_date) > new Date(),
//       );
//     } catch (err) {
//       console.error("Check plan failed", err);
//       return false;
//     }
//   };

//   const autoSubscribeFreePlan = async (uid) => {
//     try {
//       await fetch(`${BASE_URL}/subscribe/free/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ user_id: uid, plan_name: "Free" }),
//       });
//       return true;
//     } catch (err) {
//       console.error("Auto subscribe failed", err);
//       return false;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     const cleanIdentifier = identifier.trim();
//     const cleanPassword = password.trim();

//     if (!cleanIdentifier || !cleanPassword) {
//       setError("Mobile number / Email and password are required");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await fetch(`${BASE_URL}/login/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           identifier: cleanIdentifier,
//           password: cleanPassword,
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         if (data.error === "Invalid Identifier.") {
//           setError("Invalid Email/Mobile number.");
//         } else {
//           setError(data.error || "Invalid credentials");
//         }
//         return;
//       }

//       login(data.user_id, data.session_token);

//       localStorage.setItem("isAuthenticated", "true");
//       localStorage.setItem("user_id", data.user_id);
//       localStorage.setItem("session_token", data.session_token);

//       if (window.ReactNativeWebView) {
//         window.ReactNativeWebView.postMessage(
//           JSON.stringify({
//             user_id: data.user_id,
//             session_token: data.session_token,
//             username: data.username,
//           }),
//         );
//       }

//       const userRes = await fetch(`${BASE_URL}/users/${data.user_id}/`, {
//         headers: { Authorization: `Bearer ${data.session_token}` },
//       });
//       const userData = await userRes.json();

//       if (!userData.tersm_and_condition) {
//         navigate("/termsandconditions", { state: { fromLogin: true } });
//         return;
//       }

//       const userId = data.user_id;
//       const hasFreePlan = await checkHasActiveFreePlan(userId);
//       let showPopup = false;

//       if (!hasFreePlan) {
//         const subscribed = await autoSubscribeFreePlan(userId);
//         if (subscribed) {
//           showPopup = true;
//           localStorage.setItem(`free_plan_popup_shown_${userId}`, "true");
//         }
//       }

//       navigate("/dashboard", { state: { showFreePlanPopup: showPopup } });
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Reusable input style ──
//   const inputSx = {
//     backgroundColor: INPUT_BG,
//     borderRadius: "12px",
//     color: "#FFFFFF",
//     fontSize: "0.9rem",
//     "& input::placeholder": { color: "rgba(255,255,255,0.55)", opacity: 1 },
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: INPUT_BORDER,
//       borderWidth: "1.2px",
//     },
//     "&:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: GOLD_LIGHT,
//     },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: GOLD_LIGHT,
//       borderWidth: "1.5px",
//     },
//     "& .MuiInputAdornment-root svg": {
//       color: GOLD,
//     },
//   };

//   // ── Link styles (always underlined) ──
//   const goldLinkSx = {
//     color: GOLD,
//     fontSize: "0.78rem",
//     fontWeight: 600,
//     textDecoration: "underline",
//     textDecorationColor: "rgba(201,162,75,0.85)",
//     textUnderlineOffset: "3px",
//     textDecorationThickness: "1.2px",
//     "&:hover": {
//       color: GOLD_LIGHT,
//       textDecorationColor: GOLD_LIGHT,
//     },
//   };

//   const footerLinkSx = {
//     color: "rgba(255,255,255,0.85)",
//     fontSize: "0.68rem",
//     fontWeight: 500,
//     textDecoration: "underline",
//     textDecorationColor: "rgba(255,255,255,0.5)",
//     textUnderlineOffset: "3px",
//     textDecorationThickness: "1px",
//     px: 1,
//     "&:hover": {
//       color: GOLD_LIGHT,
//       textDecorationColor: GOLD_LIGHT,
//     },
//   };

//   return (
//     <Fade in timeout={700}>
//       <Box
//         sx={{
//           minHeight: "100vh",
//           position: "relative",
//           overflow: "hidden",
//           backgroundColor: "#000000",
//           backgroundImage: `url(${LoginBg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center top",
//           backgroundRepeat: "no-repeat",
//           display: "flex",
//           // ✅ move everything up — align to top instead of center
//           alignItems: "flex-start",
//           justifyContent: "center",
//           // ✅ small top padding (not too much, card shouldn't feel cramped)
//           pt: { xs: 2, sm: 3 },
//           pb: { xs: 4, sm: 6 },
//           px: 2,
//         }}
//       >
//         {/* Warm radial glow behind the logo */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: "4%",
//             left: "50%",
//             transform: "translateX(-50%)",
//             width: "70%",
//             maxWidth: 420,
//             height: 320,
//             pointerEvents: "none",
//             background:
//               "radial-gradient(closest-side, rgba(201,162,75,0.22) 0%, rgba(201,162,75,0.06) 55%, transparent 80%)",
//             filter: "blur(6px)",
//           }}
//         />

//         {/* ── Top-left gold diagonal accents ── */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: 220,
//             height: 180,
//             pointerEvents: "none",
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               top: 6,
//               left: -10,
//               width: 260,
//               height: 3,
//               background:
//                 "linear-gradient(90deg, transparent 0%, #C9A24B 30%, #F1E57C 60%, #C9A24B 90%, transparent 100%)",
//               transform: "rotate(-30deg)",
//               transformOrigin: "left top",
//             },
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               top: 30,
//               left: -10,
//               width: 200,
//               height: 2,
//               background:
//                 "linear-gradient(90deg, transparent 0%, #C9A24B 40%, #F1E57C 70%, transparent 100%)",
//               transform: "rotate(-30deg)",
//               transformOrigin: "left top",
//               opacity: 0.9,
//             },
//           }}
//         />

//         {/* ── Bottom-left gold diagonal bands ── */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             width: 260,
//             height: 260,
//             pointerEvents: "none",
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               bottom: 30,
//               left: -60,
//               width: 340,
//               height: 4,
//               background:
//                 "linear-gradient(90deg, #F1E57C 0%, #C9A24B 40%, #8C6B23 80%, transparent 100%)",
//               transform: "rotate(28deg)",
//               transformOrigin: "left bottom",
//             },
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               bottom: 0,
//               left: -40,
//               width: 300,
//               height: 2.4,
//               background:
//                 "linear-gradient(90deg, #C9A24B 0%, #8C6B23 70%, transparent 100%)",
//               transform: "rotate(28deg)",
//               transformOrigin: "left bottom",
//               opacity: 0.9,
//             },
//           }}
//         />

//         {/* ── Bottom-right gold skyline ── */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 4,
//             right: 4,
//             pointerEvents: "none",
//           }}
//         >
//           <SkylineArt width={140} height={84} />
//         </Box>

//         {/* ============ CONTENT ============ */}
//         <Container
//           maxWidth="xs"
//           sx={{ position: "relative", zIndex: 2, py: 1 }}
//         >
//           <CssBaseline />

//           {/* ===== LOGO + WORDMARK + TAGLINE (white text) ===== */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               mb: 2,
//             }}
//           >
//             <Box
//               component="img"
//               src={Property_pincoder}
//               alt="Property Pincoder"
//               sx={{
//                 width: 130,
//                 height: 130,
//                 objectFit: "contain",
//                 filter: "drop-shadow(0 0 14px rgba(201,162,75,0.65))",
//                 mb: 0.5,
//               }}
//             />

//             {/* ✅ White, with soft dark shadow so it reads over the city photo */}
//             <Typography
//               sx={{
//                 fontFamily: '"Playfair Display", Georgia, serif',
//                 fontSize: "2.1rem",
//                 fontWeight: 700,
//                 letterSpacing: 0.6,
//                 color: "#f1e57c",
//                 lineHeight: 1.1,
//                 textShadow:
//                   "0 2px 6px rgba(0,0,0,0.9), 0 0 18px rgba(0,0,0,0.7)",
//               }}
//             >
//               Property Pincoder
//             </Typography>

//             {/* ✅ White tagline, same treatment */}
//             <Typography
//               sx={{
//                 mt: 0.6,
//                 fontSize: "1.2rem",
//                 color: "#f1e57c",
//                 letterSpacing: 1.8,
//                 fontWeight: 600,
//                 textShadow:
//                   "0 2px 6px rgba(0,0,0,0.9), 0 0 14px rgba(0,0,0,0.75)",
//               }}
//             >
//               — Sale - Buy - Rent —
//             </Typography>
//               <Typography
//               sx={{
//                 mt: 0.6,
//                 fontSize: "1.2rem",
//                 color: "#f1e57c",
//                 letterSpacing: 1.8,
//                 fontWeight: 600,
//                 textShadow:
//                   "0 2px 6px rgba(0,0,0,0.9), 0 0 14px rgba(0,0,0,0.75)",
//               }}
//             >
//               — Jv/Jd - Built to Suit —
//             </Typography>
//                <Typography
//               sx={{
//                 mt: 0.6,
//                 fontSize: "1.2rem",
//                 color: "#f1e57c",
//                 letterSpacing: 1.8,
//                 fontWeight: 600,
//                 textShadow:
//                   "0 2px 6px rgba(0,0,0,0.9), 0 0 14px rgba(0,0,0,0.75)",
//               }}
//             >
//               — Action Properties —
//             </Typography>
//           </Box>

//           {/* ===== CARD ===== */}
//           <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 2.5, sm: 3.5 },
//               marginTop: "18px",
//               borderRadius: "16px",
//               background: "#050505",
//               border: `1.5px solid ${GOLD}`,
//               boxShadow:
//                 "0 0 0 1px rgba(201,162,75,0.2), 0 12px 40px rgba(0,0,0,0.8), inset 0 0 40px rgba(201,162,75,0.05)",
//               color: "#fff",
//             }}
//           >
//             {/* Welcome heading */}
//             <Typography
//               sx={{
//                 fontSize: "1.75rem",
//                 fontWeight: 800,
//                 lineHeight: 1.1,
//                 mb: 0.4,
//                 color: "#FFFFFF",
//               }}
//             >
//               Welcome{" "}
//               <Box
//                 component="span"
//                 sx={{
//                   background: `linear-gradient(180deg, ${GOLD_LIGHT} 0%, ${GOLD} 70%, ${GOLD_DARK} 100%)`,
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 Back
//               </Box>
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.82rem",
//                 color: "rgba(255,255,255,0.55)",
//                 mb: 3,
//               }}
//             >
//               Sign in to your account to continue
//             </Typography>

//             {error && (
//               <Typography
//                 sx={{
//                   color: "#FF6B6B",
//                   fontSize: "0.78rem",
//                   mb: 1.5,
//                   textAlign: "center",
//                 }}
//               >
//                 {error}
//               </Typography>
//             )}

//             <Box component="form" onSubmit={handleSubmit}>
//               {/* Identifier */}
//               <TextField
//                 fullWidth
//                 placeholder="Mobile Number or Email *"
//                 type="text"
//                 value={identifier}
//                 onChange={(e) => setIdentifier(e.target.value.toLowerCase())}
//                 variant="outlined"
//                 InputProps={{
//                   sx: inputSx,
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <PhoneIcon sx={{ fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   mb: 1.5,
//                   "& .MuiOutlinedInput-root": { paddingLeft: "6px" },
//                   "& .MuiInputBase-input": { py: 1.4, color: "#FFFFFF" },
//                 }}
//               />

//               {/* Password */}
//               <TextField
//                 fullWidth
//                 placeholder="Password *"
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 variant="outlined"
//                 InputProps={{
//                   sx: inputSx,
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setShowPassword(!showPassword)}
//                         edge="end"
//                         sx={{ color: GOLD }}
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   mb: 2,
//                   "& .MuiOutlinedInput-root": { paddingLeft: "6px" },
//                   "& .MuiInputBase-input": { py: 1.4, color: "#FFFFFF" },
//                 }}
//               />

//               {/* SIGN IN */}
//               <Button
//                 type="submit"
//                 fullWidth
//                 disabled={loading}
//                 startIcon={
//                   !loading && <Lock sx={{ fontSize: 18, color: "#000" }} />
//                 }
//                 sx={{
//                   py: 1.2,
//                   borderRadius: "10px",
//                   background: `linear-gradient(180deg, ${GOLD_LIGHT} 0%, ${GOLD} 60%, ${GOLD_DARK} 100%)`,
//                   color: "#000000",
//                   fontWeight: 800,
//                   fontSize: "0.85rem",
//                   letterSpacing: 0.8,
//                   textTransform: "uppercase",
//                   boxShadow:
//                     "0 6px 18px rgba(201,162,75,0.35), inset 0 1px 0 rgba(255,255,255,0.4)",
//                   "&:hover": {
//                     background: `linear-gradient(180deg, #FFF6A6 0%, ${GOLD_LIGHT} 60%, ${GOLD} 100%)`,
//                     boxShadow:
//                       "0 8px 22px rgba(201,162,75,0.5), inset 0 1px 0 rgba(255,255,255,0.5)",
//                   },
//                   "&.Mui-disabled": {
//                     background: "rgba(201,162,75,0.4)",
//                     color: "rgba(0,0,0,0.55)",
//                   },
//                 }}
//               >
//                 {loading ? (
//                   <CircularProgress size={22} sx={{ color: "#000" }} />
//                 ) : (
//                   "Sign In"
//                 )}
//               </Button>

//               {/* CONTINUE AS GUEST */}
//               <Button
//                 fullWidth
//                 onClick={handleGuestLogin}
//                 startIcon={
//                   <PersonIcon sx={{ fontSize: 18, color: GOLD_LIGHT }} />
//                 }
//                 sx={{
//                   mt: 1.5,
//                   py: 1.15,
//                   borderRadius: "10px",
//                   border: `1.3px solid ${GOLD}`,
//                   color: "#FFFFFF",
//                   fontWeight: 700,
//                   fontSize: "0.82rem",
//                   letterSpacing: 0.8,
//                   textTransform: "uppercase",
//                   backgroundColor: "#000",
//                   "&:hover": {
//                     borderColor: GOLD_LIGHT,
//                     backgroundColor: "rgba(201,162,75,0.08)",
//                   },
//                 }}
//               >
//                 Continue as Guest
//               </Button>

//               {/* Create account + Forgot password */}
//               <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 sx={{ mt: 2 }}
//               >
//                 <MUILink component={Link} to="/register" sx={goldLinkSx}>
//                   Create account
//                 </MUILink>
//                 <MUILink component={Link} to="/forgot" sx={goldLinkSx}>
//                   Forgot password?
//                 </MUILink>
//               </Box>

//               {/* OR divider */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   mt: 1.5,
//                   mb: 1.2,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     flex: 1,
//                     height: "1px",
//                     background:
//                       "linear-gradient(90deg, transparent, rgba(201,162,75,0.65))",
//                   }}
//                 />
//                 <Typography
//                   sx={{
//                     fontSize: "0.72rem",
//                     color: "rgba(255,255,255,0.55)",
//                     letterSpacing: 1.2,
//                     fontWeight: 600,
//                   }}
//                 >
//                   OR
//                 </Typography>
//                 <Box
//                   sx={{
//                     flex: 1,
//                     height: "1px",
//                     background:
//                       "linear-gradient(90deg, rgba(201,162,75,0.65), transparent)",
//                   }}
//                 />
//               </Box>

//               {/* Footer links */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   flexWrap: "nowrap",
//                   gap: 0,
//                 }}
//               >
//                 <MUILink
//                   component={Link}
//                   to="/termsandconditions"
//                   sx={{
//                     ...footerLinkSx,
//                     borderRight: "1px solid rgba(201,162,75,0.45)",
//                   }}
//                 >
//                   Terms & Conditions
//                 </MUILink>
//                 <MUILink
//                   component={Link}
//                   to="/privacypolicy"
//                   sx={{
//                     ...footerLinkSx,
//                     borderRight: "1px solid rgba(201,162,75,0.45)",
//                   }}
//                 >
//                   Privacy Policy
//                 </MUILink>
//                 <MUILink
//                   component={Link}
//                   to="/refundpolicy"
//                   sx={footerLinkSx}
//                 >
//                   Refund Policy
//                 </MUILink>
//               </Box>
//             </Box>
//           </Paper>
//         </Container>
//       </Box>
//     </Fade>
//   );
// };

// export default Login;



// export default Login;
// import React, { useState, useContext, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   CssBaseline,
//   TextField,
//   CircularProgress,
//   Typography,
//   InputAdornment,
//   IconButton,
//   Link as MUILink,
//   Paper,
//   Fade,
// } from "@mui/material";
// import { AuthContext } from "./../AuthContext/AuthContext";
// import {
//   Visibility,
//   VisibilityOff,
//   Lock,
//   Phone as PhoneIcon,
//   Person as PersonIcon,
// } from "@mui/icons-material";
// import { useNavigate, Link } from "react-router-dom";
// import { BASE_URL } from "./../Api/ApiUrls";

// import LoginBg from "./../../../src/Images/login-logo-bg.jpeg";

// // ── Palette ──
// const GOLD = "#C9A24B";
// const GOLD_LIGHT = "#F1E57C";
// const GOLD_DARK = "#8C6B23";
// const INPUT_BG = "#1C1C1C";
// const INPUT_BORDER = "rgba(201,162,75,0.75)";

// /* ============================================================
//    Google icon (inline SVG)
//    ============================================================ */
// const GoogleIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
//     <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
//     <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
//     <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
//     <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
//   </svg>
// );

// /* ============================================================
//    Apple icon (inline SVG)
//    ============================================================ */
// const AppleIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//     <path fill="#FFFFFF" d="M16.365 1.43c0 1.14-.42 2.2-1.18 3.02-.87.94-2.29 1.66-3.45 1.57-.14-1.12.42-2.29 1.16-3.05.86-.9 2.35-1.59 3.47-1.54zM20.8 17.06c-.5 1.15-.74 1.66-1.39 2.68-.9 1.42-2.17 3.19-3.75 3.2-1.4.01-1.76-.91-3.66-.9-1.9.01-2.29.92-3.7.9-1.58-.02-2.78-1.61-3.68-3.03C2.15 15.5 1.9 10.55 3.47 7.97c1.1-1.83 2.84-2.9 4.47-2.9 1.66 0 2.71.91 4.08.91 1.34 0 2.15-.91 4.07-.91 1.45 0 2.99.79 4.09 2.15-3.6 1.97-3.02 7.12.62 9.84z"/>
//   </svg>
// );

// const Login = () => {
//   const [identifier, setIdentifier] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const { login, guestLogin, userId, sessionId } = useContext(AuthContext);

//   useEffect(() => {
//     if (userId && sessionId) navigate("/dashboard");
//   }, [userId, sessionId, navigate]);

//   const handleGuestLogin = () => {
//     guestLogin();
//     navigate("/dashboard", { state: { isGuest: true } });
//   };

//   // ── Google / Apple placeholders ──
//   const handleGoogleLogin = () => {
//     console.log("Continue with Google clicked");
//     // TODO: hook Google OAuth here
//   };

//   const handleAppleLogin = () => {
//     console.log("Continue with Apple clicked");
//     // TODO: hook Apple OAuth here
//   };

//   const checkHasActiveFreePlan = async (uid) => {
//     try {
//       const res = await fetch(`${BASE_URL}/Get-all-plan/${uid}/`);
//       const plans = await res.json();
//       if (!Array.isArray(plans)) return false;
//       return plans.some(
//         (plan) =>
//           plan.plan_name === "Free" &&
//           plan.status === true &&
//           new Date(plan.expired_date) > new Date(),
//       );
//     } catch (err) {
//       console.error("Check plan failed", err);
//       return false;
//     }
//   };

//   const autoSubscribeFreePlan = async (uid) => {
//     try {
//       await fetch(`${BASE_URL}/subscribe/free/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ user_id: uid, plan_name: "Free" }),
//       });
//       return true;
//     } catch (err) {
//       console.error("Auto subscribe failed", err);
//       return false;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     const cleanIdentifier = identifier.trim();
//     const cleanPassword = password.trim();

//     if (!cleanIdentifier || !cleanPassword) {
//       setError("Mobile number / Email and password are required");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await fetch(`${BASE_URL}/login/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           identifier: cleanIdentifier,
//           password: cleanPassword,
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         if (data.error === "Invalid Identifier.") {
//           setError("Invalid Email/Mobile number.");
//         } else {
//           setError(data.error || "Invalid credentials");
//         }
//         return;
//       }

//       login(data.user_id, data.session_token);

//       localStorage.setItem("isAuthenticated", "true");
//       localStorage.setItem("user_id", data.user_id);
//       localStorage.setItem("session_token", data.session_token);

//       if (window.ReactNativeWebView) {
//         window.ReactNativeWebView.postMessage(
//           JSON.stringify({
//             user_id: data.user_id,
//             session_token: data.session_token,
//             username: data.username,
//           }),
//         );
//       }

//       const userRes = await fetch(`${BASE_URL}/users/${data.user_id}/`, {
//         headers: { Authorization: `Bearer ${data.session_token}` },
//       });
//       const userData = await userRes.json();

//       if (!userData.tersm_and_condition) {
//         navigate("/termsandconditions", { state: { fromLogin: true } });
//         return;
//       }

//       const userId = data.user_id;
//       const hasFreePlan = await checkHasActiveFreePlan(userId);
//       let showPopup = false;

//       if (!hasFreePlan) {
//         const subscribed = await autoSubscribeFreePlan(userId);
//         if (subscribed) {
//           showPopup = true;
//           localStorage.setItem(`free_plan_popup_shown_${userId}`, "true");
//         }
//       }

//       navigate("/dashboard", { state: { showFreePlanPopup: showPopup } });
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Reusable input style ──
//   const inputSx = {
//     backgroundColor: INPUT_BG,
//     borderRadius: "12px",
//     color: "#FFFFFF",
//     fontSize: "0.9rem",
//     "& input::placeholder": { color: "rgba(255,255,255,0.55)", opacity: 1 },
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: INPUT_BORDER,
//       borderWidth: "1.2px",
//     },
//     "&:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: GOLD_LIGHT,
//     },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: GOLD_LIGHT,
//       borderWidth: "1.5px",
//     },
//     "& .MuiInputAdornment-root svg": {
//       color: GOLD,
//     },
//   };

//   // ── Link styles (always underlined) ──
//   const goldLinkSx = {
//     color: GOLD,
//     fontSize: "0.78rem",
//     fontWeight: 600,
//     textDecoration: "underline",
//     textDecorationColor: "rgba(201,162,75,0.85)",
//     textUnderlineOffset: "3px",
//     textDecorationThickness: "1.2px",
//     "&:hover": {
//       color: GOLD_LIGHT,
//       textDecorationColor: GOLD_LIGHT,
//     },
//   };

//   return (
//     <Fade in timeout={700}>
//       <Box
//         sx={{
//           minHeight: "100vh",
//           position: "relative",
//           overflow: "hidden",
//           backgroundColor: "#000000",
//           backgroundImage: `url(${LoginBg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center top",
//           backgroundRepeat: "no-repeat",
//           display: "flex",
//           alignItems: "flex-start",
//           justifyContent: "center",
//           pt: { xs: 2, sm: 3 },
//           pb: { xs: 4, sm: 6 },
//           px: 2,
//         }}
//       >
//         {/* Warm radial glow behind the card */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: "8%",
//             left: "50%",
//             transform: "translateX(-50%)",
//             width: "70%",
//             maxWidth: 420,
//             height: 320,
//             pointerEvents: "none",
//             background:
//               "radial-gradient(closest-side, rgba(201,162,75,0.22) 0%, rgba(201,162,75,0.06) 55%, transparent 80%)",
//             filter: "blur(6px)",
//           }}
//         />

//         {/* ── Top-left gold diagonal accents ── */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: 220,
//             height: 180,
//             pointerEvents: "none",
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               top: 6,
//               left: -10,
//               width: 260,
//               height: 3,
//               background:
//                 "linear-gradient(90deg, transparent 0%, #C9A24B 30%, #F1E57C 60%, #C9A24B 90%, transparent 100%)",
//               transform: "rotate(-30deg)",
//               transformOrigin: "left top",
//             },
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               top: 30,
//               left: -10,
//               width: 200,
//               height: 2,
//               background:
//                 "linear-gradient(90deg, transparent 0%, #C9A24B 40%, #F1E57C 70%, transparent 100%)",
//               transform: "rotate(-30deg)",
//               transformOrigin: "left top",
//               opacity: 0.9,
//             },
//           }}
//         />

//         {/* ── Bottom-left gold diagonal bands ── */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             width: 260,
//             height: 260,
//             pointerEvents: "none",
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               bottom: 30,
//               left: -60,
//               width: 340,
//               height: 4,
//               background:
//                 "linear-gradient(90deg, #F1E57C 0%, #C9A24B 40%, #8C6B23 80%, transparent 100%)",
//               transform: "rotate(28deg)",
//               transformOrigin: "left bottom",
//             },
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               bottom: 0,
//               left: -40,
//               width: 300,
//               height: 2.4,
//               background:
//                 "linear-gradient(90deg, #C9A24B 0%, #8C6B23 70%, transparent 100%)",
//               transform: "rotate(28deg)",
//               transformOrigin: "left bottom",
//               opacity: 0.9,
//             },
//           }}
//         />

//         {/* ============ CONTENT ============ */}
//         <Container
//           maxWidth="xs"
//           sx={{ position: "relative", zIndex: 2, py: 1 }}
//         >
//           <CssBaseline />

//           {/* ===== CARD ===== */}
//           <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 2, sm: 3.5 },
//               marginTop: "300px",
//               borderRadius: "16px",
//               background: "#050505",
//               border: `1.5px solid ${GOLD}`,
//               boxShadow:
//                 "0 0 0 1px rgba(201,162,75,0.2), 0 12px 40px rgba(0,0,0,0.8), inset 0 0 40px rgba(201,162,75,0.05)",
//               color: "#fff",
//             }}
//           >
//             {/* Welcome heading */}
//             <Typography
//               sx={{
//                 fontSize: "1.45rem",
//                 fontWeight: 800,
//                 lineHeight: 1.15,
//                 mb: 0.5,
//                 color: "#FFFFFF",
//                 textAlign: "center",
//               }}
//             >
//               Welcome to{" "}
//               <Box
//                 component="span"
//                 sx={{
//                   background: `linear-gradient(180deg, ${GOLD_LIGHT} 0%, ${GOLD} 70%, ${GOLD_DARK} 100%)`,
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 Property Pincoder
//               </Box>
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.82rem",
//                 color: "rgba(255,255,255,0.55)",
//                 mb: 3,
//                 textAlign: "center",
//               }}
//             >
//               Login to explore and post properties
//             </Typography>

//             {error && (
//               <Typography
//                 sx={{
//                   color: "#FF6B6B",
//                   fontSize: "0.78rem",
//                   mb: 1.5,
//                   textAlign: "center",
//                 }}
//               >
//                 {error}
//               </Typography>
//             )}

//             <Box component="form" onSubmit={handleSubmit}>
//               {/* Identifier */}
//               <TextField
//                 fullWidth
//                 placeholder="Mobile Number or Email"
//                 type="text"
//                 value={identifier}
//                 onChange={(e) => setIdentifier(e.target.value.toLowerCase())}
//                 variant="outlined"
//                 InputProps={{
//                   sx: inputSx,
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <PhoneIcon sx={{ fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   mb: 1.5,
//                   "& .MuiOutlinedInput-root": { paddingLeft: "6px" },
//                   "& .MuiInputBase-input": { py: 1.4, color: "#FFFFFF" },
//                 }}
//               />

//               {/* Password */}
//               <TextField
//                 fullWidth
//                 placeholder="Password"
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 variant="outlined"
//                 InputProps={{
//                   sx: inputSx,
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setShowPassword(!showPassword)}
//                         edge="end"
//                         sx={{ color: GOLD }}
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   mb: 1.5,
//                   "& .MuiOutlinedInput-root": { paddingLeft: "6px" },
//                   "& .MuiInputBase-input": { py: 1.4, color: "#FFFFFF" },
//                 }}
//               />

//               {/* Remember Me + Forgot Password */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   mb: 2,
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                   <Box
//                     component="input"
//                     type="checkbox"
//                     sx={{
//                       width: 16,
//                       height: 16,
//                       accentColor: GOLD,
//                       cursor: "pointer",
//                     }}
//                   />
//                   <Typography
//                     sx={{
//                       fontSize: "0.75rem",
//                       color: "rgba(255,255,255,0.75)",
//                     }}
//                   >
//                     Remember Me
//                   </Typography>
//                 </Box>
//                 <MUILink
//                   component={Link}
//                   to="/forgot"
//                   sx={{
//                     ...goldLinkSx,
//                     fontSize: "0.74rem",
//                   }}
//                 >
//                   Forgot Password?
//                 </MUILink>
//               </Box>

//               {/* LOGIN */}
//               <Button
//                 type="submit"
//                 fullWidth
//                 disabled={loading}
//                 endIcon={
//                   !loading && (
//                     <Box
//                       component="span"
//                       sx={{ fontSize: 16, fontWeight: 700 }}
//                     >
//                       ›
//                     </Box>
//                   )
//                 }
//                 sx={{
//                   py: 1,
//                   borderRadius: "10px",
//                   background: `linear-gradient(180deg, ${GOLD_LIGHT} 0%, ${GOLD} 60%, ${GOLD_DARK} 100%)`,
//                   color: "#000000",
//                   fontWeight: 800,
//                   fontSize: "1rem",
//                   letterSpacing: 0.8,
//                   textTransform: "none",
//                   boxShadow:
//                     "0 6px 18px rgba(201,162,75,0.35), inset 0 1px 0 rgba(255,255,255,0.4)",
//                   "&:hover": {
//                     background: `linear-gradient(180deg, #FFF6A6 0%, ${GOLD_LIGHT} 60%, ${GOLD} 100%)`,
//                     boxShadow:
//                       "0 8px 22px rgba(201,162,75,0.5), inset 0 1px 0 rgba(255,255,255,0.5)",
//                   },
//                   "&.Mui-disabled": {
//                     background: "rgba(201,162,75,0.4)",
//                     color: "rgba(0,0,0,0.55)",
//                   },
//                 }}
//               >
//                 {loading ? (
//                   <CircularProgress size={22} sx={{ color: "#000" }} />
//                 ) : (
//                   "Login"
//                 )}
//               </Button>

//               {/* OR divider */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   mt: 1,
//                   mb: 1,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     flex: 1,
//                     height: "1px",
//                     background:
//                       "linear-gradient(90deg, transparent, rgba(201,162,75,0.65))",
//                   }}
//                 />
//                 <Typography
//                   sx={{
//                     fontSize: "0.72rem",
//                     color: "rgba(255,255,255,0.55)",
//                     letterSpacing: 1,
//                     fontWeight: 600,
//                   }}
//                 >
//                   OR
//                 </Typography>
//                 <Box
//                   sx={{
//                     flex: 1,
//                     height: "1px",
//                     background:
//                       "linear-gradient(90deg, rgba(201,162,75,0.65), transparent)",
//                   }}
//                 />
//               </Box>

//               {/* CONTINUE WITH GOOGLE + APPLE */}
//               {/* <Box
//                 sx={{
//                   display: "flex",
//                   gap: 1,
//                   mb: 1,
//                 }}
//               >
//                 <Button
//                   onClick={handleGoogleLogin}
//                   startIcon={<GoogleIcon />}
//                   sx={{
//                     flex: 1,
//                     py: 1,
//                     borderRadius: "10px",
//                     border: "1.2px solid rgba(201,162,75,0.55)",
//                     color: "#FFFFFF",
//                     fontWeight: 600,
//                     fontSize: "0.72rem",
//                     textTransform: "none",
//                     letterSpacing: 0.3,
//                     backgroundColor: "#000",
//                     minWidth: 0,
//                     "&:hover": {
//                       borderColor: GOLD_LIGHT,
//                       backgroundColor: "rgba(201,162,75,0.08)",
//                     },
//                   }}
//                 >
//                   Continue with Google
//                 </Button>

//                 <Button
//                   onClick={handleAppleLogin}
//                   startIcon={<AppleIcon />}
//                   sx={{
//                     flex: 1,
//                     py: 1,
//                     borderRadius: "10px",
//                     border: "1.2px solid rgba(201,162,75,0.55)",
//                     color: "#FFFFFF",
//                     fontWeight: 600,
//                     fontSize: "0.72rem",
//                     textTransform: "none",
//                     letterSpacing: 0.3,
//                     backgroundColor: "#000",
//                     minWidth: 0,
//                     "&:hover": {
//                       borderColor: GOLD_LIGHT,
//                       backgroundColor: "rgba(201,162,75,0.08)",
//                     },
//                   }}
//                 >
//                   Continue with Apple
//                 </Button>
//               </Box> */}

//               {/* CONTINUE AS GUEST (kept as before) */}
//               <Button
//                 fullWidth
//                 onClick={handleGuestLogin}
//                 startIcon={
//                   <PersonIcon sx={{ fontSize: 18, color: GOLD_LIGHT }} />
//                 }
//                 sx={{
//                   py: 1,
//                   borderRadius: "10px",
//                   border: `1.3px solid ${GOLD}`,
//                   color: "#FFFFFF",
//                   fontWeight: 700,
//                   fontSize: "0.82rem",
//                   letterSpacing: 0.8,
//                   textTransform: "uppercase",
//                   backgroundColor: "#000",
//                   "&:hover": {
//                     borderColor: GOLD_LIGHT,
//                     backgroundColor: "rgba(201,162,75,0.08)",
//                   },
//                 }}
//               >
//                 Continue as Guest
//               </Button>

//               {/* Sign Up link */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   mt: 1,
//                   gap: 0.8,
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     fontSize: "0.8rem",
//                     color: "rgba(255,255,255,0.75)",
//                   }}
//                 >
//                   Don&apos;t have an account?
//                 </Typography>
//                 <MUILink
//                   component={Link}
//                   to="/register"
//                   sx={{
//                     color: GOLD_LIGHT,
//                     fontSize: "0.8rem",
//                     fontWeight: 700,
//                     textDecoration: "none",
//                     "&:hover": {
//                       textDecoration: "underline",
//                       color: "#FFF6A6",
//                     },
//                   }}
//                 >
//                   Sign Up
//                 </MUILink>
//               </Box>
//             </Box>
//           </Paper>
//         </Container>
//       </Box>
//     </Fade>
//   );
// };

// export default Login;

import React, { useState, useContext, useEffect } from "react";

import {
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  CircularProgress,
  Typography,
  InputAdornment,
  IconButton,
  Link as MUILink,
  Paper,
  Fade,
} from "@mui/material";

import { AuthContext } from "./../AuthContext/AuthContext";

import {
  Visibility,
  VisibilityOff,
  Lock,
  Phone as PhoneIcon,
  Person as PersonIcon,
} from "@mui/icons-material";

import { useNavigate, Link } from "react-router-dom";
import { BASE_URL } from "./../Api/ApiUrls";

// ONLY BACKGROUND IMAGE
import LoginBg from "./../../../src/Images/login-bg-new.jpg";

// ✅ ADD THIS — put your logo file in the same Images folder
import Logo from "./../../../src/Images/logo-new.jpg";

// ─────────────────────────────────────────────
// COLORS
// ─────────────────────────────────────────────

const GOLD = "#7A3F16";
const GOLD_LIGHT = "#9B521C";
const GOLD_DARK = "#5E2D0D";

const INPUT_BG = "#FFFFFF";
const INPUT_BORDER = "rgba(100, 55, 25, 0.18)";

// ─────────────────────────────────────────────
// GOOGLE ICON
// ─────────────────────────────────────────────

const GoogleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#FFC107"
      d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
    />

    <path
      fill="#FF3D00"
      d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
    />

    <path
      fill="#4CAF50"
      d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
    />

    <path
      fill="#1976D2"
      d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
    />
  </svg>
);

// ─────────────────────────────────────────────
// APPLE ICON
// ─────────────────────────────────────────────

const AppleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#000000"
      d="M16.365 1.43c0 1.14-.42 2.2-1.18 3.02-.87.94-2.29 1.66-3.45 1.57-.14-1.12.42-2.29 1.16-3.05.86-.9 2.35-1.59 3.47-1.54zM20.8 17.06c-.5 1.15-.74 1.66-1.39 2.68-.9 1.42-2.17 3.19-3.75 3.2-1.4.01-1.76-.91-3.66-.9-1.9.01-2.29.92-3.7.9-1.58-.02-2.78-1.61-3.68-3.03C2.15 15.5 1.9 10.55 3.47 7.97c1.1-1.83 2.84-2.9 4.47-2.9 1.66 0 2.71.91 4.08.91 1.34 0 2.15-.91 4.07-.91 1.45 0 2.99.79 4.09 2.15-3.6 1.97-3.02 7.12.62 9.84z"
    />
  </svg>
);

// ─────────────────────────────────────────────
// LOGIN
// ─────────────────────────────────────────────

const Login = () => {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const {
    login,
    guestLogin,
    userId,
    sessionId,
  } = useContext(AuthContext);

  // ─────────────────────────────────────────────
  // REDIRECT
  // ─────────────────────────────────────────────

  useEffect(() => {
    if (userId && sessionId) {
      navigate("/dashboard");
    }
  }, [userId, sessionId, navigate]);

  // ─────────────────────────────────────────────
  // GUEST LOGIN
  // ─────────────────────────────────────────────

  const handleGuestLogin = () => {
    guestLogin();

    navigate("/dashboard", {
      state: { isGuest: true },
    });
  };

  // ─────────────────────────────────────────────
  // GOOGLE LOGIN
  // ─────────────────────────────────────────────

  const handleGoogleLogin = () => {
    console.log("Continue with Google clicked");

    // TODO: hook Google OAuth here
  };

  // ─────────────────────────────────────────────
  // APPLE LOGIN
  // ─────────────────────────────────────────────

  const handleAppleLogin = () => {
    console.log("Continue with Apple clicked");

    // TODO: hook Apple OAuth here
  };

  // ─────────────────────────────────────────────
  // CHECK FREE PLAN
  // ─────────────────────────────────────────────

  const checkHasActiveFreePlan = async (uid) => {
    try {
      const res = await fetch(
        `${BASE_URL}/Get-all-plan/${uid}/`
      );

      const plans = await res.json();

      if (!Array.isArray(plans)) {
        return false;
      }

      return plans.some(
        (plan) =>
          plan.plan_name === "Free" &&
          plan.status === true &&
          new Date(plan.expired_date) > new Date()
      );
    } catch (err) {
      console.error("Check plan failed", err);

      return false;
    }
  };

  // ─────────────────────────────────────────────
  // AUTO SUBSCRIBE FREE PLAN
  // ─────────────────────────────────────────────

  const autoSubscribeFreePlan = async (uid) => {
    try {
      await fetch(`${BASE_URL}/subscribe/free/`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          user_id: uid,
          plan_name: "Free",
        }),
      });

      return true;
    } catch (err) {
      console.error("Auto subscribe failed", err);

      return false;
    }
  };

  // ─────────────────────────────────────────────
  // LOGIN SUBMIT
  // ─────────────────────────────────────────────

 const handleSubmit = async (e) => {
  e.preventDefault();

  setError("");

  const cleanIdentifier = identifier.trim();
  const cleanPassword = password.trim();

  if (!cleanIdentifier || !cleanPassword) {
    setError("Mobile number / Email and password are required");
    return;
  }

  setLoading(true);

  try {
    // NEW: FCM token provided by the mobile app (empty in a normal browser)
    let fcmToken = "";
    if (window.ReactNativeWebView && window.fcmToken) {
      fcmToken = window.fcmToken;
    }

    const response = await fetch(`${BASE_URL}/login/`, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        identifier: cleanIdentifier,
        password: cleanPassword,
        fcm_token: fcmToken, // NEW
      }),
    });

    const data = await response.json();

    // LOGIN ERROR

    if (!response.ok) {
      if (data.error === "Invalid Identifier.") {
        setError("Invalid Email/Mobile number.");
      } else {
        setError(data.error || "Invalid credentials");
      }

      return;
    }

    // LOGIN SUCCESS

    login(data.user_id, data.session_token);

    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("user_id", data.user_id);
    localStorage.setItem("session_token", data.session_token);

    // REACT NATIVE WEBVIEW
    // (the AuthContext now tells the app about the token; this message is
    // kept as it was and is ignored by the app)

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          user_id: data.user_id,
          session_token: data.session_token,
          username: data.username,
        })
      );
    }

    // GET USER DATA

    const userRes = await fetch(`${BASE_URL}/users/${data.user_id}/`, {
      headers: {
        Authorization: `Bearer ${data.session_token}`,
      },
    });

    const userData = await userRes.json();

    // TERMS AND CONDITIONS

    if (!userData.tersm_and_condition) {
      navigate("/termsandconditions", {
        state: {
          fromLogin: true,
        },
      });

      return;
    }

    // FREE PLAN

    const loggedUserId = data.user_id;

    const hasFreePlan = await checkHasActiveFreePlan(loggedUserId);

    let showPopup = false;

    if (!hasFreePlan) {
      const subscribed = await autoSubscribeFreePlan(loggedUserId);

      if (subscribed) {
        showPopup = true;

        localStorage.setItem(`free_plan_popup_shown_${loggedUserId}`, "true");
      }
    }

    // DASHBOARD

    navigate("/dashboard", {
      state: {
        showFreePlanPopup: showPopup,
      },
    });
  } catch (err) {
    console.error(err);

    setError("Something went wrong. Please try again later.");
  } finally {
    setLoading(false);
  }
};

  // ─────────────────────────────────────────────
  // INPUT STYLE
  // ─────────────────────────────────────────────

  const inputSx = {
    backgroundColor: INPUT_BG,

    borderRadius: "12px",

    color: "#222",

    fontSize: "0.9rem",

    height: "52px",

    "& input": {
      color: "#222",

      paddingTop: "12px",
      paddingBottom: "12px",
    },

    "& input::placeholder": {
      color: "#999",

      opacity: 1,
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: INPUT_BORDER,

      borderWidth: "1px",
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#8B4F24",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#8B4F24",

      borderWidth: "1.5px",
    },

    "& .MuiInputAdornment-root svg": {
      color: "#222",
    },
  };

  // ─────────────────────────────────────────────
  // RETURN
  // ─────────────────────────────────────────────

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          minHeight: "100vh",

          width: "100%",

          position: "relative",

          overflow: "hidden",

          backgroundColor: "#000",

          backgroundImage: `url(${LoginBg})`,

          backgroundSize: "cover",

          backgroundPosition: "center top",

          backgroundRepeat: "no-repeat",

          display: "flex",

          flexDirection: "column",

          justifyContent: "flex-start",

          alignItems: "center",

          px: {
            xs: 1,
            sm: 2,
            md: 3,
          },

          // ✅ Small top padding — logo block sits at the very top
          // of the background image (over the skyline).
          pt: {
            xs: 2,
            sm: 3,
            md: 3,
          },

          pb: 4,
        }}
      >
        <CssBaseline />

      
{/* ───────── LOGO + BRAND TEXT ───────── */}
<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    zIndex: 2,
    mt: { xs: 0, sm: 1 },
    mb: { xs: 2, sm: 2.5 },
    px: 2.5,
    py: 1.2,
  }}
>
  {/* Logo */}
  <Box
    component="img"
    src={Logo}
    alt="Property Pincoder"
    sx={{
      width: { xs: 80, sm: 92, md: 104 },
      height: "auto",
      objectFit: "contain",
      display: "block",
      mb: 0.5,
      // white glow around the logo (no box)
      filter: "drop-shadow(0 0 8px rgba(255,255,255,0.9))",
    }}
  />

  <Box
    sx={{
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    {/* PROPERTY */}
    <Typography
      sx={{
        fontSize: { xs: "1.6rem", sm: "1.9rem", md: "2.1rem" },
        fontWeight: 800,
        letterSpacing: "2px",
        color: "#111",
        lineHeight: 1.05,
        textTransform: "uppercase",
        // textShadow:
        //   "0 0 6px rgba(255, 255, 255, 0.46), 0 0 12px rgba(255, 255, 255, 0.48), 0 0 22px rgba(255, 255, 255, 0.52)",
      }}
    >
      Property
    </Typography>

    {/* PINCODER */}
    <Typography
      sx={{
        fontSize: { xs: "1.15rem", sm: "1.35rem", md: "1.5rem" },
        fontWeight: 800,
        letterSpacing: "4px",
        color: "#111",
        lineHeight: 1.1,
        textTransform: "uppercase",
        textShadow:
          "0 0 6px rgba(255,255,255,1), 0 0 12px rgba(255,255,255,0.95), 0 0 22px rgba(255,255,255,0.8)",
      }}
    >
      Pincoder
    </Typography>

    {/* UNDERLINE */}
    <Box
      sx={{
        width: "100%",
        height: "1.5px",
        backgroundColor: "#111",
        my: 0.8,
        boxShadow:
          "0 0 6px rgba(255,255,255,1), 0 0 12px rgba(255,255,255,0.9)",
      }}
    />

    {/* FIND • POST • CONNECT */}
    <Typography
      sx={{
        fontSize: { xs: "0.62rem", sm: "0.7rem", md: "0.75rem" },
        fontWeight: 700,
        letterSpacing: "3.5px",
        color: "#111",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
        textShadow:
          "0 0 5px rgba(255,255,255,1), 0 0 10px rgba(255,255,255,1), 0 0 18px rgba(255,255,255,0.9)",
      }}
    >
      Find • Post • Connect
    </Typography>
  </Box>
</Box>
        {/* ─────────────────────────────────────
            LOGIN CONTAINER
        ───────────────────────────────────── */}

        <Container
          maxWidth={false}
          disableGutters
          sx={{
            position: "relative",

            zIndex: 2,

            width: "100%",

            maxWidth: {
              xs: "100%",
              sm: "680px",
              md: "760px",
              lg: "800px",
            },

            mx: " auto",
          }}
        >
          {/* ─────────────────────────────────────
              LOGIN CARD
          ───────────────────────────────────── */}

          <Paper
            elevation={0}
            sx={{
              width: "100%",

              p: {
               
                xs: 2,
                sm: 3,
                md: 3.5,
              },
              marginTop: "230px",

              borderRadius: {
                xs: "22px",
                sm: "28px",
              },

              background:
                "rgba(255,248,238,0.97)",

              border: "none",

              boxShadow:
                "0 10px 35px rgba(0,0,0,0.30)",

              color: "#1A1A1A",

              backdropFilter: "blur(2px)",
            }}
          >
            {/* ─────────────────────────────────
                WELCOME
            ───────────────────────────────── */}

            <Typography
              sx={{
                fontSize: {
                  xs: "1.35rem",
                  sm: "1.55rem",
                  md: "1.7rem",
                },

                fontWeight: 800,

                lineHeight: 1.1,

                mb: 0.2,

                color: "#171717",

                textAlign: "center",
              }}
            >
              Welcome to
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "1.65rem",
                  sm: "1.9rem",
                  md: "2.1rem",
                },

                fontWeight: 900,

                lineHeight: 1.05,

                mb: 0.5,

                color: "#5A2D14",

                textAlign: "center",
              }}
            >
              Property Pincoder
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "0.78rem",
                  sm: "0.85rem",
                  md: "0.9rem",
                },

                color: "#777",

                mb: {
                  xs: 1.5,
                  sm: 2,
                },

                textAlign: "center",
              }}
            >
              Login to explore and post properties
            </Typography>

            {/* ─────────────────────────────────
                ERROR
            ───────────────────────────────── */}

            {error && (
              <Typography
                sx={{
                  color: "#D32F2F",

                  fontSize: "0.78rem",

                  mb: 1,

                  textAlign: "center",

                  fontWeight: 600,
                }}
              >
                {error}
              </Typography>
            )}

            {/* ─────────────────────────────────
                FORM
            ───────────────────────────────── */}

            <Box
              component="form"
              onSubmit={handleSubmit}
            >
              {/* MOBILE / EMAIL */}

              <TextField
                fullWidth
                placeholder="Mobile Number or Email"
                type="text"
                value={identifier}
                onChange={(e) =>
                  setIdentifier(
                    e.target.value.toLowerCase()
                  )
                }
                variant="outlined"
                InputProps={{
                  sx: inputSx,

                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon
                        sx={{
                          fontSize: 20,
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 1,

                  "& .MuiOutlinedInput-root": {
                    paddingLeft: "6px",
                  },
                }}
              />

              {/* PASSWORD */}

              <TextField
                fullWidth
                placeholder="Password"
                type={
                  showPassword
                    ? "text"
                    : "password"
                }
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value)
                }
                variant="outlined"
                InputProps={{
                  sx: inputSx,

                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock
                        sx={{
                          fontSize: 20,
                        }}
                      />
                    </InputAdornment>
                  ),

                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowPassword(
                            !showPassword
                          )
                        }
                        edge="end"
                        sx={{
                          color: "#222",
                          p: 0.5,
                        }}
                      >
                        {showPassword ? (
                          <VisibilityOff
                            fontSize="small"
                          />
                        ) : (
                          <Visibility
                            fontSize="small"
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 0.8,

                  "& .MuiOutlinedInput-root": {
                    paddingLeft: "6px",
                  },
                }}
              />

              {/* ─────────────────────────────
                  REMEMBER + FORGOT
              ───────────────────────────── */}

              <Box
                sx={{
                  display: "flex",

                  alignItems: "center",

                  justifyContent:
                    "space-between",

                  mb: 1.2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",

                    alignItems: "center",

                    gap: 0.6,
                  }}
                >
                  <Box
                    component="input"
                    type="checkbox"
                    sx={{
                      width: 16,

                      height: 16,

                      accentColor: GOLD,

                      cursor: "pointer",

                      margin: 0,
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: "0.75rem",

                      color: "#333",
                    }}
                  >
                    Remember Me
                  </Typography>
                </Box>

                <MUILink
                  component={Link}
                  to="/forgot"
                  sx={{
                    color: "#6B3210",

                    fontSize: "0.75rem",

                    fontWeight: 600,

                    textDecoration:
                      "underline",

                    cursor: "pointer",

                    "&:hover": {
                      color: "#8B4F24",
                    },
                  }}
                >
                  Forgot Password?
                </MUILink>
              </Box>

              {/* ─────────────────────────────
                  LOGIN BUTTON
              ───────────────────────────── */}

              <Button
                type="submit"
                fullWidth
                disabled={loading}
                sx={{
                  py: 1.15,

                  minHeight: "48px",

                  borderRadius: "28px",

                  background:
                    "linear-gradient(90deg, #6B3210 0%, #A65D16 50%, #6B3210 100%)",

                  color: "#FFFFFF",

                  fontWeight: 800,

                  fontSize: {
                    xs: "0.95rem",
                    sm: "1rem",
                  },

                  textTransform: "none",

                  boxShadow:
                    "0 5px 15px rgba(107,50,16,0.25)",

                  "&:hover": {
                    background:
                      "linear-gradient(90deg, #542508 0%, #8B4810 50%, #542508 100%)",
                  },

                  "&.Mui-disabled": {
                    background: "#B99B80",

                    color: "#FFFFFF",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress
                    size={21}
                    sx={{
                      color: "#FFFFFF",
                    }}
                  />
                ) : (
                  <>
                    Login

                    <Box
                      component="span"
                      sx={{
                        fontSize: "1.5rem",

                        ml: 0.8,

                        lineHeight: 0.7,
                      }}
                    >
                      →
                    </Box>
                  </>
                )}
              </Button>

              {/* ─────────────────────────────
                  OR
              ───────────────────────────── */}

              <Box
                sx={{
                  display: "flex",

                  alignItems: "center",

                  gap: 1,

                  mt: 1.2,

                  mb: 1,
                }}
              >
                <Box
                  sx={{
                    flex: 1,

                    height: "1px",

                    background:
                      "rgba(100,60,30,0.20)",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: "0.7rem",

                    color: "#777",

                    fontWeight: 600,
                  }}
                >
                  OR
                </Typography>

                <Box
                  sx={{
                    flex: 1,

                    height: "1px",

                    background:
                      "rgba(100,60,30,0.20)",
                  }}
                />
              </Box>

              <Button
                fullWidth
                onClick={handleGuestLogin}
                startIcon={
                  <PersonIcon
                    sx={{
                      fontSize: 19,
                      color: "#6B3210",
                    }}
                  />
                }
                endIcon={
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1.3rem",

                      color: "#6B3210",

                      lineHeight: 0.7,
                    }}
                  >
                    →
                  </Box>
                }
                sx={{
                  py: 1,

                  minHeight: "44px",

                  borderRadius: "25px",

                  border:
                    "1.3px solid #8B4F24",

                  color: "#6B3210",

                  fontWeight: 700,

                  fontSize: {
                    xs: "0.76rem",
                    sm: "0.82rem",
                  },

                  textTransform: "none",

                  backgroundColor:
                    "rgba(255,255,255,0.35)",

                  "&:hover": {
                    borderColor:
                      "#6B3210",

                    backgroundColor:
                      "rgba(139,79,36,0.06)",
                  },
                }}
              >
                Continue as Guest
              </Button>

              {/* ─────────────────────────────
                  CREATE ACCOUNT
              ───────────────────────────── */}

              <Box
                sx={{
                  display: "flex",

                  justifyContent:
                    "center",

                  alignItems: "center",

                  flexWrap: "wrap",

                  gap: 0.5,

                  mt: 1.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: "0.72rem",
                      sm: "0.78rem",
                    },

                    color: "#333",
                  }}
                >
                  Don't have an account?
                </Typography>

                <MUILink
                  component={Link}
                  to="/register"
                  sx={{
                    color: "#6B3210",

                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.82rem",
                    },

                    fontWeight: 800,

                    textDecoration: "none",

                    "&:hover": {
                      color: "#8B4F24",

                      textDecoration:
                        "underline",
                    },
                  }}
                >
                  Create New Account →
                </MUILink>
              </Box>
            </Box>
          </Paper>
        </Container>
      </Box>
    </Fade>
  );
};

export default Login;